import React, { useState, useEffect, useContext } from 'react';
import { useCookies } from 'react-cookie';
import { GeneralContext } from '../../context/generalContext';
import { settingsAPI } from '../../services/GeneralService';
import '../../styles/App.scss';
import classes from './ClosedReserveModal.module.scss';
import ModalPopup from '../ModalPopup/ModalPopup';

export default function ClosedReserveModal() {
  const { subdomainIsActive, subdomain, currentCityAddress } = useContext(GeneralContext);
  const { data: settings } = settingsAPI.useFetchAllSettingsQuery();

  const [, setCookie] = useCookies([]);

  // хуки для управления попапом
  const targetRef = React.createRef();
  const [showModal, setShowModal] = useState(false);
  const onShowModal = () => {
    setShowModal(true);
  };
  const onCloseModal = () => {
    setShowModal(false);
    setCookie(['reserveClosed'], true);

    document.body.style.overflow = 'visible';
    document.body.style.position = '';
    document.body.style.width = '';
  };
  useEffect(() => {
    if (settings?.statusSite === 'off') setTimeout(() => onShowModal(), 8000);
  }, [subdomainIsActive, subdomain, settings]);

  const text = {
    title: 'Резерв столов через форму временно недоступен.',
    title_en: 'Table reservation via the form is&nbsp;temporarily unavailable.',
    text: `На&nbsp;сайте ведутся технические работы&nbsp;&mdash; для бронирования стола, пожалуйста, позвоните по&nbsp;номеру&nbsp;
      <a href="tel:${currentCityAddress?.tel || '+74954320990'}" 
        class=${classes.tel}
      >${currentCityAddress?.telModified || '+7 (495) 432-09-90'}</a>`,

    text_en: `Technical work is&nbsp;underway on&nbsp;the website&nbsp;&mdash; to&nbsp;book a&nbsp;table, please call&nbsp;
      <a href="tel:${currentCityAddress?.tel || '+74954320990'}" 
        class=${classes.tel}
      >${currentCityAddress?.telModified || '+7 (495) 432-09-90'}</a>`,
  };

  return <ModalPopup showModal={showModal} targetRef={targetRef} text={text} onCloseModal={onCloseModal} />;
}
